module.exports = __webpack_public_path__ + "img/logo.29d33c40.svg";